import React, { Component } from 'react'

import MainSection from './MainSection'
import NewTemplates from './NewTemplates'
import EasyUse from './EasyUse'
import GalleryArea from './GalleryArea'
import BottomSection from './BottomSection'

class OldLanding extends Component {
    render() {
        const {
            totalTemplateCount,
            newTemplates,
            allFinishedVideosCount,
            gallerys
        } = this.props

        return <>
            <MainSection
                {...this.props}
                totalTemplateCount={totalTemplateCount}
                handleClickHashtag={this.props.handleClickHashtag}
            />
            <NewTemplates
                {...this.props}
                newTemplates={newTemplates}
                onThumbnailClicked={this.props.onThumbnailClicked}
            />
            <EasyUse />
            <GalleryArea
                {...this.props}
                allFinishedVideosCount={allFinishedVideosCount}
                gallerys={gallerys}
                handleGalleryThumbnailClicked={this.props.handleGalleryThumbnailClicked}
            />
            <BottomSection
                {...this.props}
            />
        </>
    }
}

export default OldLanding